<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-secondary itemTitle="청약신청" bg="/images/form/application/visual.jpg">
                <template #title>청약신청</template>
            </sub-head-secondary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <v-row align="center">
                <v-col cols="12" lg="6" order-lg="2">
                    <v-card tile class="pa-24px px-md-40px py-md-84px">
                        <tit-wrap class="tit-wrap--sm">
                            <tit-wrap class="tit-wrap--xs">
                                <tit class="font-secondary primary--text">Felix</tit>
                            </tit-wrap>
                            <tit>성북 펠릭스 청약신청 접수/조회</tit>
                        </tit-wrap>

                        <tit-wrap class="tit-wrap--sm">
                            <v-row v-if="!isClosed" class="row--xs">
                                <v-col cols="auto">
                                    <application-dialog ref="applicationDialog">
                                        <template #activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" tile x-large color="black" class="white--text v-btn--width-fixed" @click="blockUntilOpen">
                                                <span class="font-size-14 font-size-lg-16">청약신청/조회</span>
                                            </v-btn>
                                        </template>
                                    </application-dialog>
                                </v-col>
                                <v-col cols="auto">
                                    <v-btn tile x-large color="primary" class="v-btn--width-fixed" to="/subscription/recruitment">
                                        <span class="font-size-14 font-size-lg-16">모집공고 다운로드</span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <div v-else class="tit">청약신청이 마감되었습니다.</div>
                        </tit-wrap>
                        <sheet-primary>
                            <v-row>
                                <v-col cols="12">
                                    <v-row class="row--xxs">
                                        <v-col cols="12">
                                            <txt class="font-weight-bold txt--dark">주택위치</txt>
                                        </v-col>
                                        <v-col>
                                            <txt class="font-weight-bold">
                                                서울특별시 성북구 하월곡동 88-222필지 <br />
                                                (4호선 미아사거리역 3번출구)
                                            </txt>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <v-row class="row--xxs">
                                        <v-col cols="12">
                                            <txt class="font-weight-bold txt--dark">공급호수</txt>
                                        </v-col>
                                        <v-col>
                                            <txt class="font-weight-bold">
                                                총 299 세대 중 민간임대 240세대 <br />
                                                (특별공급 48세대, 일반공급 192세대)
                                            </txt>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </sheet-primary>
                    </v-card>
                </v-col>
                <v-col cols="12" lg="6">
                    <v-img max-width="588" src="/images/sub/application/application.jpg" class="mx-auto" />
                </v-col>
            </v-row>
        </page-section-primary>
    </app-primary>
</template>

<script>
import { APPLICATION_TYPE } from "@/assets/variables";
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadSecondary from "@/sets/parents/pages/sub-head-secondary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import FormInput from "@/components/client/form/form-input.vue";

import TitWrap from "@/components/publish/styles/typography/tit-wrap.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

import SheetPrimary from "@/components/publish/parents/sheets/sheet-primary.vue";
import api from "@/api";

import ApplicationDialog from "@/components/client/application/application-dialog.vue";

export default {
    components: {
        AppPrimary,
        SubHeadSecondary,
        PageSectionPrimary,
        FormInput,

        TitWrap,
        Tit,
        Txt,

        SheetPrimary,

        ApplicationDialog,
    },
    data() {
        return {
            APPLICATION_TYPE,
            surveyURL: "/",
        };
    },
    computed: {
        // tempBlock
        today() {
            return this.$dayjs();
        },
        open() {
            return this.$dayjs("2025-01-02 00:00:00");
        },
        deadline() {
            return this.$dayjs("2025-01-06 23:59:59");
        },
        isOpen() {
            return this.today.isAfter(this.open);
        },
        isClosed() {
            return this.today.isAfter(this.deadline);
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        blockUntilOpen() {
            // tempBlock
            // this.$refs.applicationDialog.show = true;
            if (this.isOpen) {
                this.$refs.applicationDialog.show = true;
            } else {
                alert("01월 02일 00시부터 접수 가능합니다.");
            }
        },
        async search() {
            try {
                const { surveyURL } = await api.v1.setting.getSuveryURL();
                this.surveyURL = surveyURL;
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>
